module.exports = __webpack_public_path__ + "img/pure.ddee227c.png";